<template>
  <div>
    <el-drawer
      title="更新日志"
      :visible.sync="showDrawer"
      custom-class="notice-drawer"
      :direction="direction"
      :show-close="false"
      :before-close="handleClose"
    >
      <div class="journal">
        <div
          class="journal-day"
          :class="{ 'new-version': item.isNew }"
          v-for="(item, index) in logLists"
          :key="index"
        >
          <span class="time">{{ item.updateTime }} </span>
          <div class="content">
            <p class="version">
              {{ item.isNew ? "当前版本" : "" }}{{ item.version
              }}<span class="is-new" v-if="item.isNew">new</span>
            </p>
            <span
              class="sub-title"
              v-for="(subItem, subIndex) in item.subBody"
              :key="subIndex"
              v-html="subItem"
            ></span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import yuqueClient from "@/utils/yuqueClient";
import { getSysUpdateLogs } from "@/utils/apis";
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",
      logLists: [],
    };
  },
  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // showDrawer(val) {
    //   if (val) {
    //     this.drawer = val;
    //   }
    // },
  },
  methods: {
    handleClose(done) {
      console.log("关闭");
      this.$emit("closeNoticeDrawer");
      // console.log("关闭", done());
      // done();
      //   this.$confirm("确认关闭？")
      //     .then((_) => {
      //       done();
      //     })
      //     .catch((_) => {});
    },
    async getLogList() {
      let logLists = [];
      // let { data } = await yuqueClient.get(
      //   "/v2/repos/bq9rk1/product/docs/yrmibf",
      //   {
      //     raw: 1,
      //   }
      // );
      let data = await getSysUpdateLogs();
      data = JSON.parse(data.result);
      // console.log("data", data);
      let replaceBody = data.data.body.replace(
        /<a[a-zA-Z\s\w="'\\>]+<\/a>/g,
        ""
      );
      // console.log("replaceBody", replaceBody);
      replaceBody = replaceBody.replace(/(#+)\s+(v[\w.]+)/g, "$2");
      // console.log("replaceBody1111", replaceBody);
      // console.log("replaceBody222",replaceBody.split(/^v\d+\.\d+\.\d+$/));
      const pattern = /(v\d+\.\d+\.\d+)/;
      replaceBody = replaceBody.split(pattern).filter((item) => Boolean(item));
      // console.log("replaceBody------", replaceBody);
      for (let i = 0; i < replaceBody.length - 1; i = i + 2) {
        let itemLog = {};
        itemLog.version = replaceBody[i];
        let subBody = replaceBody[i + 1]
          .split("\n")
          .filter((item) => Boolean(item));
        let updateTime = subBody[0].replace(/更新日期：/, "");
        updateTime = updateTime.match(/([\u4E00-\u9FFF\w]+日)/g)[0];
        // console.log("match", match);
        itemLog.updateTime = updateTime;
        subBody = subBody.slice(2);
        itemLog.subBody = subBody;
        itemLog.isNew = i == 0;
        logLists.push(itemLog);
      }
      this.logLists = logLists;
    },
  },
  mounted() {
    this.getLogList();
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-drawer__wrapper {
  .notice-drawer {
    .el-drawer__header {
      position: relative;
      height: 58px;
      border-bottom: 1px solid#E6E7E9;
      padding: 0;
      padding-left: 20px;
      color: #333;
      z-index: 9;
      box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.03);
      margin-bottom: 0px;
      &::after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        // background: #f0f4fe;
        z-index: -1;
        background: linear-gradient(90deg, #97edfc 0%, #efdffb 100%);
        filter: blur(45px);
        opacity: 0.6;
      }
    }
    .journal {
      width: 100%;
      //   height: 500px;
      overflow: auto;
      .journal-day {
        position: relative;
        padding-left: 133px;
        .time {
          position: absolute;
          left: -1px;
          top: 26px;
          height: 26px;
          line-height: 26px;
          width: 134px;
          text-align: left;
          padding-left: 22px;
          font-size: 14px;
          color: #80848b;
          background: #fff;
          z-index: 2;
        }
        .content {
          padding: 26px 31px 21px 0;
          position: relative;
          text-align: left;
          &:before {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background: #e6e7e9;
            width: 1px;
            content: "";
          }
          .version {
            position: relative;
            padding-left: 32px;
            font-size: 14px;
            font-weight: 700;
            color: #80848b;
            height: 26px;
            line-height: 26px;
            z-index: 2;
            &:before,
            &:after {
              position: absolute;
              content: "";
              top: 50%;
              transform: translateY(-50%);
              border-radius: 14px;
            }
            &:before {
              left: -5px;
              width: 9px;
              height: 9px;
              border: 1px solid #0057ff;
              background: #fff;
            }
            &:after {
              left: -2px;
              width: 5px;
              height: 5px;
              background: #0057ff;
            }
            span {
              &.is-new {
                display: inline-block;
                margin: 0;
                margin-left: 6px;
                text-indent: 0;
                color: #fe4509;
                padding: 0;
              }
            }
          }

          span {
            text-indent: 1em;
            display: block;
            padding-left: 32px;
            margin-top: 10px;
            font-size: 14px;
            color: #80848b;
            line-height: 1.2;
            &.sub-title {
              color: #80848b;
              text-indent: 0em;
            }
            &.summary {
              line-height: 1.4;
              // display: block;
              margin-top: 20px;
              // color: #333;
            }
          }
        }
        &.new-version {
          .time {
            color: #333;
          }
          .content {
            .version {
              color: #333;
            }
            .sub-title {
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>
